/* global dataLayer */
import config from '../config/main.js'
/**
 *
 * @param {string} trigger - element which holds the extra data attributes
 *
 */

// Can be used with makeGtmCall(el)
// Either add as data attributes in the markup el has:
//  - <a href="#" data-gtm-event="pdf-download" data-gtm-name="example.pdf"> download </a>
// or adding in the js before calling makeGtmCall(el)
//  - el.dataset.gtmEvent = 'pdf-download'; el.dataset.gtmName = 'example.pdf'
// every data attribute with "gtm" will go in the object

export const makeGtmCall = (trigger) => {
    const object = {}
    const keys = Object.keys(trigger.dataset)

    for (const key of keys) {
        if (key.includes('gtm')) {
            const cleanKey = key.replace('gtm', '')
            const formattedKey =
                cleanKey.charAt(0).toLowerCase() + cleanKey.slice(1)

            object[formattedKey] = trigger.dataset[key]
        }
    }

    if (config.trackingDebug) {
        console.info(object)
    }
    if (
        typeof dataLayer === 'undefined' ||
        typeof trigger.dataset.gtmEvent === 'undefined'
    ) {
        return false
    }

    dataLayer.push(object)
}

export const trackReadingRoom = () => {
    if (window.location.href.includes('reading-room')) {
        document.addEventListener('resultsLoaded', (e) => {
            const selectDropDown = e.detail.find(el => el.name === 'article[category]')
            if(selectDropDown) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'reading_room_submit',
                    results: selectDropDown.value === 'null' ? 'Everything' : selectDropDown.value,
                })
            }

        })
    }
}

export const trackLogin = () => {
    if (sessionStorage.getItem('loginTracked')) {
        return false
    }
    if (window.location.search.includes('loggedin')) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            event: 'investor_log_in',
        })
        sessionStorage.setItem('loginTracked', true)
    }
}